export default __webpack_public_path__ + "static/lendingTreeBadgeCertifiedLender2022-54d9ee510b4c5977a3e3f4efaff2355e.png";